export default __webpack_public_path__ + "static/media/soul-card.455cbea8.png";